import React from 'react';
import PropTypes from 'prop-types';
import Rater from 'react-rater';
import './status-pill.scss';
import { getStatusPillStyle } from '../../../helpers/statuses';
import { makeFirstLetterCapital } from '../../../helpers/utils';

const StatusPill = ({
  className,
  status,
  originalStatus,
  isClose,
  onClose,
  index,
  isLast,
  onPress,
  isSM,
  backgroundColor,
}) => {
  // const pillStyle = getStatusPillStyle(originalStatus);
  return (
    <div
      className={`${isClose ? 'status-pill-close' : 'status-pill'} ${
        isLast ? '' : isSM ? 'margin-right-11' : 'mr-3'
      }`}
      style={{
        backgroundColor: backgroundColor || '#000000',
        width: 'fit-content',
        paddingLeft: 10,
        paddingRight: 10,
      }}
    >
      <span
        className='status-pill-text'
        onClick={() => {
          if (onPress) {
            onPress(index);
          }
        }}
        style={{
          cursor: 'pointer',
          color: backgroundColor === '#000000' ? '#ffffff' : null,
        }}
      >
        {makeFirstLetterCapital(status)}
      </span>
      {isClose ? (
        <div
          className='glyph-icon simple-icon-close delete-image ml-2'
          onClick={() => {
            if (onClose) {
              onClose(index);
            }
          }}
        />
      ) : null}
    </div>
  );
};

export default StatusPill;
